import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var _excluded = ["type"];
import { FieldType } from '@beefco/types';
import { AnyField, BooleanField, ChildrenField, ChoiceField, NumberField, StringField, TextField } from "./Field";
import { Library } from "./Library";
import { Component } from "./Component";
export var LibraryFactory = /*#__PURE__*/function () {
  function LibraryFactory() {
    _classCallCheck(this, LibraryFactory);
  }
  _createClass(LibraryFactory, null, [{
    key: "createField",
    value: function createField(_ref) {
      var type = _ref.type,
        params = _objectWithoutProperties(_ref, _excluded);
      switch (type) {
        case FieldType.NODE:
          return new ChildrenField(params);
        case FieldType.BOOLEAN:
          return new BooleanField(params);
        case FieldType.NUMBER:
          return new NumberField(params);
        case FieldType.ANY:
          return new AnyField(params);
        case FieldType.STRING:
          return new StringField(params);
        case FieldType.TEXT:
          return new TextField(params);
        case FieldType.CHOICE:
          return new ChoiceField(params);
        default:
          throw new Error("Unknown type ".concat(type, " in call to createField factory method"));
      }
    }
  }, {
    key: "createComponent",
    value: function createComponent(_ref2) {
      var id = _ref2.id,
        fields = _ref2.fields;
      var fieldInstances = fields.map(this.createField);
      return new Component({
        componentId: id,
        fields: fieldInstances
      });
    }

    // TODO: change towards separate nestable libraries
    // Libraries are flatten for now to reduce complexity
  }, {
    key: "createLibrary",
    value: function createLibrary(libraryDSL) {
      var _this = this;
      var components = libraryDSL.components.map(function (component) {
        return _this.createComponent(component);
      });
      return new Library(components);
    }
  }]);
  return LibraryFactory;
}();